import { useContext, useEffect } from "react";
import { useNavigate } from "react-router";
import WorkflowContext from "./context/WorkflowContext";

const StepSelector: React.FC = () => {
  const { activeStep, currentWorkflow, steps } = useContext(WorkflowContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (currentWorkflow && activeStep > -1) {
      const currentStep = steps[activeStep];

      if (
        currentStep.isCompleted &&
        currentStep.approvalRequired &&
        !currentStep.isApproved
      ) {
        switch (currentStep.code) {
          case "draft-for-feedback":
            navigate("waiting-feedback", { relative: "route", replace: true });
            break;
          case "final-draft":
            navigate("waiting-draft-approval", {
              relative: "route",
              replace: true,
            });
            break;
          case "final-version":
            navigate("waiting-final-approval", {
              relative: "route",
              replace: true,
            });
            break;
          case "metadata":
            navigate("waiting-publication-tasks", {
              relative: "route",
              replace: true,
            });
            break;
          case "general-information-delete":
            navigate("waiting-delete-approval", {
              relative: "route",
              replace: true,
            });
            break;
          default:
            navigate("waiting-feedback", { relative: "route", replace: true });
        }
      } else if (currentStep.code == "deleted" && !currentStep.isCompleted) {
        navigate("waiting-delete", {
          relative: "route",
          replace: true,
        });
      } else {
        navigate(currentStep.code, { relative: "route", replace: true });
      }
    }
  }, [currentWorkflow, activeStep, steps, navigate]);

  return <></>;
};

export default StepSelector;
